<template>
  <div>
    <component :is="retailListComponent"
               :active-item="vuexSelectedRetail"
               :list-data="vuexRetailListData"/>
  </div>

</template>

<script>

  import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  import ProductWmRetailList from './ProductWmRetailList'
  import StockBreakRetailList from './StockBreakRetailList'
  import PriceAuditionRetailList from './PriceAuditionRetailList'
  import {reportParameters} from '../../library/requestParameters/generalKeyApiAnalysisRequestParameters'

  export default {
    name: '',
    mixins: [DimensionUtils, GeneralUtils],
    components: {
      ProductWmRetailList,
      StockBreakRetailList,
      PriceAuditionRetailList
    },
    data () {
      return {
        activeItem: null,
        filterMerge: {}
      }
    },
    created () {
      this.style = `height: ${this.vuexAvailableHeight}px; overflow: scroll; overflow-x:hidden;`
    },
    beforeDestroy () {
      this.$eventHub.$off('grid-metric-wide-one-metric-is-ready')
    },
    watch: {},
    computed: {
      vuexAvailableHeight () {
        return this.$store.state.appAvailableHeight - 50
      },
      vuexSelectedReport () {
        return this.$store.state.generalKeyKpiAnalysis.selectedReport
      },
      retailListComponent () {
        return this.$_generalUtils_deepJsonCopy(reportParameters[this.vuexSelectedReport].retailListComponent)
      },
      vuexRetailListData () {
        // Todo create mixin to copy and evaluate computed data from vuex
        let a = this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.retailListSelectorData)
        if (a === undefined || a === null) {
          return []
        } else {
          return a['data']
        }
      },
      vuexSelectedRetail () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.generalKeyKpiAnalysis.selectedRetail)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/components/GeneralKeyKpiAnalysis/RetailListSelector.vue